import { useState, useMemo, useEffect, useRef } from "react";

import { clearAllTableFilters, onChangeFilters, onTabChange, clearSelectedRowsData } from "../../../redux/features/table/tableSlice";
import TableFilters from "../../../Components/common/TableGrid/TableFilters";
import TableTabs from "../../../Components/common/TableGrid/TableTabs";
import TableGrid from "../../../Components/common/TableGrid";
import { ReactComponent as Warning } from "../../../assets/images/icon_svg/warning.svg";
import { ReactComponent as tripstoday } from '../../../assets/images/icon_svg/bord_icon.svg';
import { ReactComponent as onpremises } from '../../../assets/images/icon_svg/dis_icon.svg';
import { ReactComponent as inprogress }  from '../../../assets/images/icon_svg/truck_icon.svg';
import { ReactComponent as arriving }  from '../../../assets/images/slotplanning/arriving.svg';
import { useSelector, useDispatch } from "react-redux";
import { useTruckOrdersQuery, useToggleSlotStatusMutation } from "../../../redux/services/ARFSM";

import { ReactComponent as EyeIcon } from "../../../assets/images/slotplanning/Eye_Icon 1.svg";
import { ReactComponent as ArchiveIcon } from "../../../assets/images/slotplanning/archive_icon.svg";
import { ReactComponent as RouteIcon } from "../../../assets/images/route.svg";
import CommonCard from "../../../Components/common/CommonCard";
import { toast } from "react-toastify";
import ConfModal from "../../../Components/common/ConfModal";
import { withRFSToken } from "../../../Services/axios";
import { GETDESTINATION } from "../../../Utils/conts";


const TruckOrders = ({ onDetails }) => {

  const isMounted = useRef(false);
  const [modalConf, setModalConf] = useState(false);
  const [preFilter, setPreFilter] = useState(false);
  const [confData, setConfData] = useState({});
  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
  const dispatch = useDispatch();
  const [getDestination, setGetDestination] = useState([]);
  const fetchDestination = async () => {
      try {
          const res = await withRFSToken.post(GETDESTINATION, {})
              .then(function (res) {
                  const innerData = res.data.response_data;
                  const transformedData = innerData ? innerData.map(item => ({
                      value: item.port_code,
                      label: item.port_code,
                      // address: item.address,
                      // station_id: item.station_id
                  })) : [];
                  setGetDestination(transformedData);
                  // dispatch(onChangeFilters({ ...filters, loading_station: ["FRA"] }));
                  // const sFilter = { loading_station: ['FRA'] };
                  // localStorage.setItem('PreFilter', JSON.stringify(sFilter));
                  // setPreFilter(true)
              });

      } catch (error) {
          console.error('Error fetching data:', error);
      }
  };
   useEffect(() => {
     dispatch(onTabChange({ key: 'tab', value: "A" }));
      if (isMounted.current) return;
      fetchDestination();
      isMounted.current = true;
    //    setTimeout(() => {
    //     const sFilter = { loading_station: ['FRA'] };
    //     localStorage.setItem('PreFilter', JSON.stringify(sFilter));
    //     dispatch(onChangeFilters(sFilter));
    //     setPreFilter(true);
    // }, 0);
  }, []);

   const buildFilterParams = (filtersObj) => {
        const params = {};
        Object.entries(filtersObj).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                return;
            }
            if (Array.isArray(value)) {
                params[key] = JSON.stringify(value); // [187,186]
            } else {
                params[key] = value;
            }
        });
        if (Object.keys(params).length > 0) {
            params.is_filter = true;
        }
        return params;
    };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);

    const params = {
      ...filterParams,
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
      recordstartindex: pageDetails.recordstartindex,
      recordendindex: pageDetails.recordendindex,
    };

    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }

    if (tab?.value && tab.value !== "all" && tab.key) {
      params[tab.key] = tab.value;
    }
    return params;
  }, [filters, pageDetails, sortby]);

  const { data: myData, isFetching, refetch } = useTruckOrdersQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  const filtersConfig = [
    {
      type: "input",
      field: "truck_number",
      placeholder: "Search Truck No.",
    },
    {
      type: "date",
      field: "truck_date",
      placeholder: "Truck Date",
      class: "date_search"
    },
     {
      type: "multiselect",
      field: "order_status",
      placeholder: "Status",
      options: [
        {label: "Planned" , value: "Planned"},
        {label: "Shipments Received" , value: "Shipments Received"},
        {label: "Manifested" , value: "Manifested"},
        {label: "Departed" , value: "Departed"},
        {label: "Arrived" , value: "Arrived"},
      ],
    },
    {
      type: "multiselect",
      field: "loading_station",
      placeholder: "Boardpoint",
      class: 'dw-13',
      options: getDestination?.map((item) => ({
        label: item.label,
        value: item.value,
      })) || [],
    },
    {
      type: "multiselect",
      field: "unloading_station",
      placeholder: "Offpoint",
      class: 'dw-12',
      options: getDestination?.map((item) => ({
        label: item.label,
        value: item.value,
      })) || [],
    },
     {
      type: "multiselect",
      field: "has_discrepancy",
      placeholder: "Discrepancy",
      options: [
        {label: "Detected" , value: "1"},
        {label: "None" , value: "0"},
      ],
    },
  ];
  const tabsConfig = [
    { label: "All", value: "all", paramKey: 'tab' },
    { label: "Open", value: "A", paramKey: "tab" },
    { label: "Archive", value: "R", paramKey: "tab" },
  ];

  // const dispatch = useDispatch();

  const columns = [
    {
      label: "", field: "actions", enableSearch: false, cls: 'single_action', cls: 'tw-3',
      renderCell: (row) => (<div className="tb_grid_actions">
        <EyeIcon className="icon_light_gray" style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            loadDetails(row);
          }}
        />
      </div>),
    },
    { label: "Truck No", field: "truck_number", enableSearch: false, cls: 'tw-6' },
    { label: "Truck Date", field: "truck_date", enableSearch: false, cls: 'tw-10' },
    {
      label: "Status", field: "order_status", enableSearch: false, cls: 'tw-5',
      // renderCell: (row) => {
      //   const status = row.status_type;
      //   return (
      //     <div className={`status ${status === "Open" ? "bg-gry" : status === "Completed" ? "bgc-grn" : "bgc-org"}`}>
      //       <span className="stat-txt">{status}</span>
      //     </div>
      //   );
      // },
    },
    { label: "DIS", field: "dis", enableSearch: false, cls: 'tw-6',
      renderCell: (row) => {
       if(row?.discrepancies?.length > 0){
        return(<><Warning /></>)
      }
      }
     },
    {
      label: "Route", field: "trip_type", enableSearch: false, cls: 'tw-6',
      renderCell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-between route_info">
              <span className="stat-txt">{row.loading_station}</span>
              <span className="stat-txt">{row.unloading_station}</span>
            </div>
            <RouteIcon  className="route_icon"/>
          </>
        );
      },
    },
    { label: "STD", field: "loading_date", enableSearch: false, cls: 'tw-6' },
    { label: "STA", field: "unloading_date", enableSearch: false, cls: 'tw-6' },
    { label: "Volume", field: "volume", enableSearch: false, cls: 'tw-6' },
    { label: "Trucker", field: "trucker_name", enableSearch: false },

  ];

const handleMoveToActArc = () => {
      const isActiveTab = tab?.value === 'A';
      setConfData({
        header: `Selected Data move to ${isActiveTab ? 'Archive' : 'Active'}`,
        subHeader: `Are you sure you want to ${isActiveTab ? 'Archive' : 'Activate'}?`,
        primaryBtn: 'Confirm',
        secondaryBtn: 'Cancel',
        modalConf: tabChangeConf,
      });
      setModalConf(true);
    };
  const tabChangeConf = async () => {
      const isActiveTab = tab?.value === 'A';
      const payload = {
        ids: selectedRows.map(row => row.id),
      };
      try {
        const res = await withRFSToken.post('toggle-truck-status',payload);
        if (res.data.response_code === 200) {
          dispatch(clearSelectedRowsData(true));
          toast.success(res.data.response_msg)
          setModalConf(false);
          refetch();
        } else {
          toast.error(res.data.response_msg);
        }
      } catch (error) {
        console.error('Error updating status:', error);
        toast.error('Something went wrong');
      }
  };
  const confModalClose = () => {
    setModalConf(false);
  }
  const bulkActions = tab?.value === "A"
    ? [{ label: "Archive", action: handleMoveToActArc, icon: ArchiveIcon }]
    : tab?.value === "R"
      ? [{ label: "Activate", action: handleMoveToActArc, icon: ArchiveIcon }]
      : [];
  const cardBtnClick = (name) => {
      let cardFilter = {}
      if (name === 'Discrepancies') {
          cardFilter = { has_discrepancy: ['1'] }
      } else if (name === 'In Transit') {
          cardFilter = { order_status: ['Departed'] }
      } 
      dispatch(onChangeFilters(cardFilter));
  }      
  const cards = [
    { icon: 'tripstoday', title: 'Open Truck Orders', value: myData?.OpenTruckOrders },
    { icon: 'onpremises', title: 'Discrepancies', value: myData?.Discrepancies, btn : "Set Filter"  },
    { icon: 'inprogress', title: 'In Transit', value: myData?.InTransit, btn : "Set Filter"  },
    { icon: 'arriving', title: ' - ', value: myData?.nextTwoHours },
  ]
  const iconMap = { tripstoday, onpremises, inprogress, arriving, };

  const loadDetails = async (data) => {
    localStorage.setItem('TODetails', data.id);
    const ed = data.truck_number + '/' + data.truck_date.split(' ')[0]
    onDetails('', 'TOD', ed)
  }

  return (
    <>
    {modalConf &&
          <ConfModal
              header={confData.header}
              subHeader={confData.subHeader}
              modalConf={confData.modalConf}
              closeModal={confModalClose}
              primaryBtn={confData.primaryBtn}
              secondaryBtn={confData.secondaryBtn}
          />
      }
      <div className="main-content">
        {cards?.length ?
          <div className="card-bx">
            {cards?.map((item, index) => (
              <CommonCard icon={iconMap[item.icon]} title={item.title} value={item.value} btn={item.btn} btnClick={cardBtnClick}/>
            ))}
          </div>
          : <></>
        }
        <div className="d-flex justify-content-between align-items-center mb-3">
          <TableFilters filtersConfig={filtersConfig} pref={preFilter} />
          <TableTabs tabs={tabsConfig} />
        </div>

        <div>
          <TableGrid
            columns={columns}
            rows={myData?.Rows}
            checkboxSelection={true}
            totalRecords={myData?.TotalRows || 0}
            onClickRow={(row) => {
              console.log("Clicked Row:", row);
            }}
            loading={isFetching}
            bulkActions={bulkActions}
            rowKey="id"
             pref={preFilter}
          />
        </div>
      </div>
    </>
  )
}

export default TruckOrders